<template>

  <div>
    <deal-conditions v-if="deal && screenThree.show1" ref="dealConditions" :view-only="!screenThree.show1" :device-label="deviceDisplayName">
      <div v-if="!model.imei" slot="identifier" class="info-table-input__line cell2">
        <input class="inpt" :value="oldIMEI" maxlength="15" :disabled="isFinalDealState || !screenThree.show1"
          :class="oldIdentifierStatus.valid ? 'active' : 'notFill'"
          @beforeinput="handleScreenIdentifierBeforeInput($event, 'old')"
          @paste="handleScreenIdentifierPaste($event, 'old')"
          @input="handleScreenIdentifierInput($event, 'old')" aria-label="IMEI/SN устройства" />
        <div class="identifier-status" :class="`identifier-status--${oldIdentifierStatus.state}`" aria-live="polite">{{ oldIdentifierStatus.message }}</div>
      </div>
    </deal-conditions>

    <transition
      name="slide-left"
      mode="out-in">

      <div
        v-if="screenThree.show1 && !isFinalDealState && user.flowType != 'mts'">
        <div
          v-if="!deal || deal.state === 'assessment'"
          class="buymodal-block__body">

          <div
            class="body-info">
            <div
              class="body-info__title">
              {{ mtsOfferTitle }}
              
            </div>
            <div
              class="body-info__block screenThree">
              <div
                class="info-table">
                <span v-if="manual > 1">
              <div
                class="body-info__title">
                Оформление заявки в ТГ боте
              </div>
              <div v-if="manual > 1 && manual < 10">
                <p>Для оформления TradeIn требуется перейти в ТГ бот</br>
                Ваша уникальная ссылка для перехода в бота: <a target="_blank" :href="'https://t.me/tkitradein_bot?start=' + model.btag">https://t.me/tkitradein_bot?start={{model.btag}}</a></br>
                QR код для перехода в бота:</p>
                <qr-code :text="'https://t.me/tkitradein_bot?start=' + model.btag"></qr-code>
              </div>
              <div v-if="manual == 10">
                <p>Заявка успешно оформлена, можете продолжить оформление.</p>
              </div>
              <div v-if="manual == 11">
                <p>Доп.скидка и стоимость устройства изменились, пожалуйста, сообщите новые данные клиенту</p>
              </div>
            </span>
                <div
                  class="info-table__line">
                  <div
                    class="label">
                    Устройство
                  </div>
                  <div
                    class="value">
                    <span>{{ deviceDisplayName }}</span>
                    <!-- <span>{{ model.mobile.modelOrigin }}</span> -->
                  </div>
                </div>
                <div
                  class="info-table__line" v-if="!(!model.imei && user.flowType == 'mvm')">
                  <div
                    class="label">
                    {{ model.imei ? `IMEI${model.imei2 ? '1' : ''}` : 'IMEI/SN' }}
                  </div>
                  <div v-if="model.imei"
                    class="value">
                    {{ model.imei }}
                  </div>
                  <div  v-if="!model.imei"
                    class="info-table-input__line cell2">
                    <input
                      class="inpt"
                      :value="oldIMEI"
                      maxlength="15"
                      @beforeinput="handleScreenIdentifierBeforeInput($event, 'old')"
                      @paste="handleScreenIdentifierPaste($event, 'old')"
                      @input="handleScreenIdentifierInput($event, 'old')"
                      id="oldIMEI"
                      :class="oldIdentifierStatus.valid ? 'active' : 'notFill'" />
                    <label
                      v-if="manual<=1"
                      for="oldIMEI"
                      class="label"
                      :class="!oldIdentifierStatus.valid ? 'notFill' : ''">
                      IMEI/SN устройства
                    </label>
                    <div
                      class="identifier-status"
                      :class="`identifier-status--${oldIdentifierStatus.state}`"
                      aria-live="polite">
                      {{ oldIdentifierStatus.message }}
                    </div>
                  </div>
                </div>
                <div
                  class="info-table__line" v-if="!(!model.imei && user.flowType == 'mvm')">
                  <div
                    class="label">
                    Грейд
                  </div>
                  <div
                    class="value">
                    <span v-if="scorring!=1 && scorring!=2 && scorring!=5" >{{ user.org != 22 ? grade : grade == "Grade A" ? "Grade H" : grade == "Grade С" ? "Grade C" : grade == "Grade C" ? "Grade D" : grade == "Grade D" ? "Grade Z" : grade }}</span>
                    <span v-if="scorring==1 || scorring==2" class="confirm" @click.prevent="confirm()">
                      
                      {{ user.org != 22 ? grade : grade == "Grade A" ? "Grade H" : grade == "Grade С" ? "Grade C" : grade == "Grade C" ? "Grade D" : grade == "Grade D" ? "Grade Z" : grade }}
                      <svg fill="#ff3131" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>warning</title> <path d="M30.555 25.219l-12.519-21.436c-1.044-1.044-2.738-1.044-3.782 0l-12.52 21.436c-1.044 1.043-1.044 2.736 0 3.781h28.82c1.046-1.045 1.046-2.738 0.001-3.781zM14.992 11.478c0-0.829 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5v7c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-7zM16.501 24.986c-0.828 0-1.5-0.67-1.5-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.83-0.672 1.5-1.5 1.5z"></path> </g></svg>
                      <span class="color">(Требуется подтвердить состояние)</span>
                    </span>
                    <span v-if="scorring==5 && user.flowType != 'mvm'" class="confirm">
                      {{ user.org != 22 ? grade : grade == "Grade A" ? "Grade H" : grade == "Grade С" ? "Grade C" : grade == "Grade C" ? "Grade D" : grade == "Grade D" ? "Grade Z" : grade }}
                      <svg fill="#ff3131" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>warning</title> <path d="M30.555 25.219l-12.519-21.436c-1.044-1.044-2.738-1.044-3.782 0l-12.52 21.436c-1.044 1.043-1.044 2.736 0 3.781h28.82c1.046-1.045 1.046-2.738 0.001-3.781zM14.992 11.478c0-0.829 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5v7c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-7zM16.501 24.986c-0.828 0-1.5-0.67-1.5-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.83-0.672 1.5-1.5 1.5z"></path> </g></svg>
                      <span class="color">(Цена и скидка изменились!)</span>
                    </span>
                    <span class="description" v-if="grade!='Grade A' && user.flowType != 'mvm'" @click="openGrade ? openGrade = false : openGrade = true"><span :hidden="openGrade">Подробнее  <i class="arrow down"></i></span><span :hidden="!openGrade">Скрыть  <i class="arrow up"></i></span></span>
                  </div>
                  <div class="answers" :class="openGrade ? 'open' : ''">
                    <div v-for="(g) in questions">
                      <span v-if="haveGroupAnswer(g)">
                        <h4>{{ g.name }}</h4>
                        <ul>
                          <template v-for="(q) in g.questions">
                            <li v-if="answers.find((element) => { if (element.id == q.id){return element.answer}})">
                              <svg v-if="minimumGrade() == q.grade" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ff3131" stroke-width="0.00024000000000000003" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.624"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7.83335 12C7.4963 12 7.19244 12.2088 7.06346 12.5291C6.93447 12.8494 7.00577 13.2181 7.2441 13.4632L11.4107 17.7489C11.7362 18.0837 12.2638 18.0837 12.5893 17.7489L16.7559 13.4632C16.9942 13.2181 17.0655 12.8494 16.9365 12.5291C16.8076 12.2088 16.5037 12 16.1666 12H14V7C14 6.44771 13.5523 6 13 6H11C10.4477 6 10 6.44771 10 7V12H7.83335Z" fill="#ff3131"></path> </g></svg>
                              <svg v-if="!(minimumGrade() == q.grade)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#a6a6a6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#a6a6a6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 4"></path> </g></svg>
                              {{q.question}}
                            </li>
                          </template>
                          <li class="allGood">Устройство не имеет повреждений</li>
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && subsidies && (manual == null || manual <= 1 || (manual > 1 && chooseSubsidy) )"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    Покупаемое устройство
                  </div>
                  <div
                    class="value">
                    <div>
                      <multiselect :disabled="manual>1" v-model="chooseSubsidy" :options="subsidies" placeholder="Покупаемое устройство" selectLabel="Выбрать" deselectLabel="Убрать" selectedLabel="Выбрано" label="deviceModel" track-by="subsidyId"></multiselect>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && manual && chooseSubsidy"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    Цвет устройства
                  </div>
                  <div
                    class="value">
                    <div>
                      <multiselect :disabled="manual>1" v-model="manualData.chooseColor" :options="color" placeholder="Выберите цвет устройства" selectLabel="Выбрать" deselectLabel="Убрать" selectedLabel="Выбрано" label="name" track-by="value"></multiselect>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && manual && chooseSubsidy"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    Объем памяти
                  </div>
                  <div
                    class="value">
                    <div>
                      <multiselect :disabled="manual>1" v-model="manualData.chooseStorage" :options="storage" placeholder="Выберите объема памяти устройства" selectLabel="Выбрать" deselectLabel="Убрать" selectedLabel="Выбрано" label="name" track-by="value"></multiselect>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && manual && chooseSubsidy"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    IMEI/SN
                  </div>
                  <div
                    class="value">
                    <div>
                      <div
                        class="info-table-input">
                        <div
                          class="info-table-input__line">
                          <input
                            :disabled="manual>1"
                            class="inpt"
                            :value="manualData.newImei"
                            maxlength="15"
                            @beforeinput="handleScreenIdentifierBeforeInput($event, 'new')"
                            @paste="handleScreenIdentifierPaste($event, 'new')"
                            @input="handleScreenIdentifierInput($event, 'new')"
                            id="newImei"
                            :class="newIdentifierStatus.valid ? 'active' : 'notFill'" />
                          <label
                            v-if="manual<=1"
                            for="newImei"
                            class="label">
                            
                            IMEI/SN нового устройства
                          </label>
                          <div
                            class="identifier-status"
                            :class="`identifier-status--${newIdentifierStatus.state}`"
                            aria-live="polite">
                            {{ newIdentifierStatus.message }}
                          </div>
                        </div>
                        
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && manual && chooseSubsidy"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    Артикул
                  </div>
                  <div
                    class="value">
                    <div>
                      <div
                        class="info-table-input">
                        <div
                          class="info-table-input__line">
                          <input
                            :disabled="manual>1"
                            class="inpt"
                            v-model.trim="manualData.newArticle"
                            id="newArticle"
                            :class="manualData.newArticle ? 'active' : ''" />
                          <label
                            v-if="manual<=1"
                            for="newArticle"
                            class="label">
                            
                            Артикул устройства
                          </label>
                        </div>
                        
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!deal && manual && chooseSubsidy"
                  class="info-table__line selecttable">
                  <div
                    class="label">
                    Цена устройства
                  </div>
                  <div
                    class="value">
                    <div>
                      <div
                        class="info-table-input">
                        <div
                          class="info-table-input__line">
                          <input
                            :disabled="manual>1"
                            class="inpt"
                            v-model.trim="manualData.newPrice"
                            v-mask="'###############'"
                            id="newPrice"
                            :class="manualData.newPrice ? 'active' : ''" />
                          <label
                            v-if="manual<=1"
                            for="newPrice"
                            class="label">
                            
                            Цена устройства
                          </label>
                        </div>
                        
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="info-image" v-if="!deal">
                <!-- Итоговая цена -->
                <div
                  v-if="price"
                  class="info-image__price">
                  <div
                    class="info-image__price-title">
                    <span v-if="scorring!=3 && scorring != 4">Максимальная стоимость до:</span>
                    <span v-if="scorring==3 || scorring==4">Итоговая стоимость:</span>
                  </div>
                  <div
                    class="info-image__price-text"
                    v-if="!chooseSubsidy">
                    {{new Intl.NumberFormat("ru-RU").format(Number(price)) }} {{user.currency}}
                  </div>
                  <div
                    class="info-image__price-text"
                    v-if="chooseSubsidy">
                    {{ new Intl.NumberFormat("ru-RU").format(Number(price) + Number(chooseSubsidy.subsidyPrice)) }} {{user.currency}}
                  </div>
                </div>

                <!-- Разбивка цены -->
                <div
                  v-if="(price) && user.org!=22 && chooseSubsidy"
                  class="info-image__price">
                  <div
                    v-if="chooseSubsidy"
                    class="info-image__price-discount first">
                    <b>Доп.скидка:</b><br>
                    {{new Intl.NumberFormat("ru-RU").format(Number(chooseSubsidy.subsidyPrice))}} {{user.currency}}
                  </div>
                  <div
                    v-if="!ourDiscount"
                    class="info-image__price-discount">
                    <b>Цена устройства:</b><br>
                    {{new Intl.NumberFormat("ru-RU").format(Number(price))}} {{user.currency}}
                  </div>
                  <div
                    class="info-image__price-discount"
                    v-if="ourDiscount">
                    <b>Цена устройства + акция:</b> <br>
                    {{ new Intl.NumberFormat("ru-RU").format(Number(price) - Number(ourDiscount)) }} {{user.currency}} + {{ new Intl.NumberFormat("ru-RU").format(Number(ourDiscount)) }} {{user.currency}}
                  </div>
                </div>
                
              </div>
              
            </div>
            <!-- <div v-if="scorring==1 || scorring==2" class="scorring">
              <h2>Подтверждение состояния устройства:</h2>
              <p>Для этого вам нужно отправить фото выкупаемого устройства в Telegram боте</br>
              Ваша уникальная ссылка для перехода в бот: <a target="_blank" :href="'https://t.me/tki_tradein_bot?start=' + model.btag">https://t.me/tki_tradein_bot?start={{model.btag}}</a></p>
              <p class="qrcode_text">QR код для перехода в бота:</p>
              <qr-code :text="'https://t.me/tki_tradein_bot?start=' + model.btag"></qr-code>
            </div> -->
            <div v-if="scorring==4">
              <h2>Устройство не прошло проверку на состояние, проведите оценку устройства повторно и внимательно отвечайте на вопросы</h2>
            </div>
          </div>

        </div>

        <div
          class="buymodal-block__footer">
          <button
            v-if="user.flowType != 'mvm'"
            type="button"
            class="btn cancel"
            @click.prevent="$emit('changeScreen', {type: 'prev', id: 2})">
            Назад
          </button>
          <button
            type="button"
            class="btn cancel"
            @click.prevent="handleLeave()">
            Отменить
          </button>
          <button
            type="button"
            class="btn next"
            v-if="scoringRefreshExpired"
            :disabled="scoringRefreshLoading"
            :class="scoringRefreshLoading ? 'disabled' : ''"
            @click.prevent="refreshScoringStatus()">
            {{ scoringRefreshLoading ? 'Обновляем...' : 'Обновить' }}
          </button>
          <button
            type="button"
            class="btn next"
            v-if="scorring!=1 && scorring!=2"
            :class="!canProceedWithIdentifiers ? 'disabled' : ''"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            :disabled="!!deal && (deal.state === 'cancel' || deal.state === 'refund')"
            @click.prevent="next()">
            Продолжить
          </button>
          <label
            v-if="(scorring==1 || scorring==2) && showPreliminaryCheckbox"
            class="checkbox-container footer-checkbox">
            Предварительная оценка
            <input type="checkbox" v-model="preliminaryValue">
            <span class="checkmark"></span>
          </label>
          <button
            type="button"
            class="btn next error"
            v-if="scorring==1 || scorring==2"
            :class="{ disabled: !canProceedWithIdentifiers }"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            @click.prevent="startMtsAssessment()">
            Оценить
          </button>
        </div>

      </div>

      <div
        v-if="screenThree.show1 && !isFinalDealState && user.flowType == 'mts'">
        <div
          v-if="!deal || deal.state === 'assessment'"
          class="buymodal-block__body">

          <div
            class="body-info">
            <div
              class="body-info__title">
              Наше предложение
              
            </div>
            <div
              class="body-info__block screenThree">
              <div
                class="info-table">
                <div
                  class="info-table__line">
                  <div
                    class="label">
                    Устройство
                  </div>
                  <div
                    class="value">
                    <span>{{ deviceDisplayName }}</span>
                  </div>
                </div>
                <div
                  class="info-table__line" v-if="model.imei">
                  <div
                    class="label">
                    IMEI{{ model.imei2 ? '1' : '' }}
                  </div>
                  <div v-if="model.imei"
                    class="value">
                    {{ model.imei }}
                  </div>
                </div>
                <div
                  class="info-table__line" v-if="model.imei2">
                  <div
                    class="label">
                    IMEI2
                  </div>
                  <div v-if="model.imei2"
                    class="value">
                    {{ model.imei2 }}
                  </div>
                </div>
                <div
                  class="info-table__line" >
                  <div
                    class="label">
                    {{ isPreliminaryAssessment ? 'Предварительный грейд' : 'Грейд' }}
                  </div>
                  <div
                    class="value">
                    <span v-if="scorring==3 || scorring==4 || scorring==5 || scorring==6 || hasPendingAssessmentNavigation || isActiveVideoAssessment">
                      {{ grade == "Grade A" ? "Grade H" : grade == "Grade С" ? "Grade C" : grade == "Grade C" ? "Grade C" : grade == "Grade E" ? "Grade Z" : grade }}
                    </span>

                    <span v-if="(scorring==1 || scorring==2) && !hasPendingAssessmentNavigation && !isActiveVideoAssessment" class="confirm" @click.prevent="confirm()">
                      <svg fill="#ff3131" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>warning</title> <path d="M30.555 25.219l-12.519-21.436c-1.044-1.044-2.738-1.044-3.782 0l-12.52 21.436c-1.044 1.043-1.044 2.736 0 3.781h28.82c1.046-1.045 1.046-2.738 0.001-3.781zM14.992 11.478c0-0.829 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5v7c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-7zM16.501 24.986c-0.828 0-1.5-0.67-1.5-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.83-0.672 1.5-1.5 1.5z"></path> </g></svg>
                      <span class="color">(Требуется оценить устройство)</span>
                    </span>
                  </div>
                </div>
                <div
                  class="info-table__line" v-if="model.mobile.damageList">
                  <div
                    class="label">
                    Повреждения
                  </div>
                  <div
                    class="value">
                    <div v-if="typeof model['mobile']['damageList'] === 'string'" v-for="(damage, index) in model['mobile']['damageList'].split(',')" :key="index">
                      {{ damage.trim() }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="info-image" v-if="!deal">
                <!-- Итоговая цена -->
                <div
                  v-if="price"
                  class="info-image__price">
                  <div
                    class="info-image__price-title">
                    <span v-if="isActiveVideoAssessment">Стоимость устройства:</span>
                    <span v-if="isPreliminaryAssessment">Предварительная стоимость до:</span>
                    <span v-if="!isPreliminaryAssessment && !isActiveVideoAssessment && ((scorring!=3 && scorring != 4) || next_step == 'questions')">Максимальная стоимость до:</span>
                    <span v-if="!isPreliminaryAssessment && !isActiveVideoAssessment && (scorring==3 || scorring==4) && next_step != 'questions'">Итоговая стоимость:</span>
                  </div>
                  <div
                    class="info-image__price-text"
                    v-if="!chooseSubsidy">
                    {{new Intl.NumberFormat("ru-RU").format(Number(price)) }} {{user.currency}}
                  </div>
                  <div
                    class="info-image__price-text"
                    v-if="chooseSubsidy">
                    {{ new Intl.NumberFormat("ru-RU").format(Number(price) + Number(chooseSubsidy.subsidyPrice)) }} {{user.currency}}
                  </div>
                </div>

                
              </div>
              
            </div>
            <div v-if="isPreliminaryAssessment">
              <h2>Это предварительная оценка. Для продолжения загрузите новые фото устройство без стекла/пленки.</h2>
            </div>
            <div v-if="isActiveVideoAssessment" class="assessment-warning">
              <strong>Перед завершением выкупа требуется дополнительная видеопроверка устройства.</strong>
            </div>
            <!-- <div v-if="scorring==1 || scorring==2" class="scorring">
              <h2>Подтверждение состояния устройства:</h2>
              <p>Для этого вам нужно отправить фото выкупаемого устройства в Telegram боте</br>
              Ваша уникальная ссылка для перехода в бот: <a target="_blank" :href="'https://t.me/tki_tradein_bot?start=' + model.btag">https://t.me/tki_tradein_bot?start={{model.btag}}</a></p>
              <p class="qrcode_text">QR код для перехода в бота:</p>
              <qr-code :text="'https://t.me/tki_tradein_bot?start=' + model.btag"></qr-code>
            </div> -->
            <div v-if="scorring==4">
              <h2>Устройство не прошло проверку на состояние, проведите оценку устройства повторно и внимательно отвечайте на вопросы</h2>
            </div>
          </div>

        </div>

        <div
          class="buymodal-block__footer">
          <button
            v-if="user.flowType != 'mvm' && (user.flowType != 'mts' &&(scorring==3 || scorring==4))"
            type="button"
            class="btn cancel"
            @click.prevent="$emit('changeScreen', {type: 'prev', id: 2})">
            Назад
          </button>
          <button
            type="button"
            class="btn cancel"
            @click.prevent="handleLeave()">
            Отменить
          </button>
          <button
            type="button"
            class="btn next"
            v-if="scoringRefreshExpired"
            :disabled="scoringRefreshLoading"
            :class="scoringRefreshLoading ? 'disabled' : ''"
            @click.prevent="refreshScoringStatus()">
            {{ scoringRefreshLoading ? 'Обновляем...' : 'Обновить' }}
          </button>
          <button
            type="button"
            class="btn next"
            v-if="(hasPendingAssessmentNavigation || (scorring!=1 && scorring!=2)) && !isPreliminaryAssessment && !isActiveVideoAssessment"
            :class="!canProceedWithIdentifiers ? 'disabled' : ''"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            :disabled="!!deal && (deal.state === 'cancel' || deal.state === 'refund')"
            @click.prevent="next()">
            Продолжить
          </button>
          <label
            v-if="(scorring==1 || scorring==2) && showPreliminaryCheckbox && !isActiveVideoAssessment && !hasPendingAssessmentNavigation"
            class="checkbox-container footer-checkbox">
            Предварительная оценка
            <input type="checkbox" v-model="preliminaryValue">
            <span class="checkmark"></span>
          </label>
          <button
            type="button"
            class="btn next error"
            v-if="(scorring==1 || scorring==2) && !isActiveVideoAssessment && !hasPendingAssessmentNavigation"
            :class="{ disabled: !canProceedWithIdentifiers }"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            @click.prevent="startMtsAssessment()">
            Оценить
          </button>
          <button
            type="button"
            class="btn next error"
            v-if="isActiveVideoAssessment"
            :class="{ disabled: !canProceedWithIdentifiers }"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            @click.prevent="startVideoAssessment()">
            Пройти видеопроверку
          </button>
          <button
            type="button"
            class="btn next error"
            v-if="isPreliminaryAssessment"
            :class="{ disabled: !canProceedWithIdentifiers }"
            :aria-disabled="String(!canProceedWithIdentifiers)"
            @click.prevent="requestFinalAssessment()">
            Получить финальную оценку
          </button>
        </div>

      </div>

      <user-info
        v-if="screenThree.show2"
        @leave="$emit('leave')" 
        @changeScreen="changeScreen"
        />

      <all-info
        v-if="screenThree.show3"
        @leave="$emit('leave')"
        @changeScreen="changeScreen"
        />
        
      <sign-contract
        v-if="screenThree.show4"
        @leave="$emit('leave')"
        @changeScreen="changeScreen" />

    </transition>

    <div class="popup-overlay" v-if="buyoutCheckPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <h3>{{ buyoutCheckPopupTitle }}</h3>
        </div>
        <div class="popup-body">
          <p>{{ buyoutCheckPopupMessage }}</p>
        </div>
        <div class="popup-footer popup-footer--spread">
          <button class="btn cancel" @click.prevent="handleBuyoutCheckPopupClose">
            Закрыть
          </button>
          <button
            v-if="buyoutCheckPopupMode === 'buyout_check_unavailable'"
            class="btn next error"
            @click.prevent="continueBuyoutWithRisk">
            Продолжить с риском
          </button>
        </div>
      </div>
    </div>

    <div class="popup-overlay" v-if="assessmentResultPopup.visible">
      <div class="popup-container assessment-result-popup">
        <div class="popup-header">
          <h3>{{ assessmentResultPopup.title }}</h3>
        </div>
        <div class="popup-body">
          <p>{{ assessmentResultPopup.message }}</p>
          <div v-if="assessmentResultPopup.showChanges" class="assessment-result-popup__changes">
            <p v-if="assessmentResultPopup.previousGrade || assessmentResultPopup.currentGrade">
              <strong>Грейд:</strong>
              {{ formatAssessmentGrade(assessmentResultPopup.previousGrade) }}
              →
              {{ formatAssessmentGrade(assessmentResultPopup.currentGrade) }}
            </p>
            <p v-if="assessmentResultPopup.previousPrice !== null || assessmentResultPopup.currentPrice !== null">
              <strong>Стоимость:</strong>
              {{ formatAssessmentPrice(assessmentResultPopup.previousPrice) }}
              →
              {{ formatAssessmentPrice(assessmentResultPopup.currentPrice) }}
            </p>
          </div>
          <div v-if="assessmentResultPopup.reasons.length" class="assessment-result-popup__reasons">
            <strong>Причины изменения:</strong>
            <ul>
              <li v-for="(reason, index) in assessmentResultPopup.reasons" :key="index">
                {{ reason }}
              </li>
            </ul>
          </div>
          <p v-else-if="assessmentResultPopup.showChanges" class="assessment-result-popup__reason-empty">
            Причина изменения не указана.
          </p>
        </div>
        <div class="popup-footer">
          <button
            type="button"
            class="btn next"
            :disabled="assessmentResultLoading"
            :class="assessmentResultLoading ? 'disabled' : ''"
            @click.prevent="continueAfterAssessmentResult()">
            {{ assessmentResultLoading
              ? 'Проверяем...'
              : assessmentResultPopup.action === 'acknowledge'
                ? 'Я понял'
                : 'Продолжить' }}
          </button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect'
import UserInfo from './ScreenThree/UserInfo';
import AllInfo from './ScreenThree/AllInfo';
import SignContract from './ScreenThree/SignContract';
import buyoutCheckMixin from './buyoutCheckMixin';
import DealConditions from './ScreenThree/DealConditions';
import {
  IDENTIFIER_MAX_LENGTH,
  IDENTIFIER_REASONS,
  createOptionalIdentifierStatus,
  createPossibleEidStatus,
  createTooLongIdentifierStatus,
  getInvalidIdentifierPopupMessage,
  getProjectedIdentifierValue,
  isPossibleEidAttempt,
  trackIdentifierOverflowAttempt,
  validateDeviceIdentifier,
} from '@/utils/deviceIdentifier';

export default {
  mixins: [buyoutCheckMixin],
  components: {
    DealConditions,
    UserInfo,
    AllInfo,
    SignContract,
    Multiselect
  },
  data() {
    return {
      screenOrderBtag: this.$store.state.buyphones.model && this.$store.state.buyphones.model.btag,
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        // { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        // { key: 'Capacity', name: 'Объем' },
        // { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ],
      chooseSubsidy: null,
      manualData: {
        chooseColor: null,
        chooseStorage: null,
        newArticle: null,
        newImei: null,
        newPrice: null
      },
      openGrade: false,
      oldIMEI: '',
      color: [{"name": "Awesome Yellow", "value": "Awesome Yellow"},{"name": "Amber Yellow", "value": "Amber Yellow"},{"name": "Titanium Black", "value": "Titanium Black"},{"name": "Cream", "value": "Cream"},{"name": "Phantom Black", "value": "Phantom Black"},  {"name": "Phantom White", "value": "Phantom White"},  {"name": "Green", "value": "Green"},  {"name": "Gray", "value": "Gray"},  {"name": "Pink Gold", "value": "Pink Gold"},  {"name": "Burgundy", "value": "Burgundy"},  {"name": "Green New", "value": "Green New"},  {"name": "Violet New", "value": "Violet New"},  {"name": "Gray New", "value": "Gray New"},  {"name": "Gold", "value": "Gold"},  {"name": "Black", "value": "Black"},  {"name": "Beige", "value": "Beige"},  {"name": "Light pink", "value": "Light pink"},  {"name": "Dark Gray", "value": "Dark Gray"},  {"name": "Silver", "value": "Silver"},  {"name": "Blue", "value": "Blue"},  {"name": "Lavender", "value": "Lavender"},  {"name": "Purple", "value": "Purple"},  {"name": "Midnight Black", "value": "Midnight Black"},  {"name": "Graphite", "value": "Graphite"},  {"name": "Cream", "value": "Cream"},  {"name": "Mint", "value": "Mint"},  {"name": "Icy Blue", "value": "Icy Blue"}],
      storage: [{"name": "128GB", "value": "128GB"},{"name": "256GB", "value": "256GB"},{"name": "512GB", "value": "512GB"},{"name": "1TB", "value": "1TB"}],
      scorringCheckTimer: null,
      scoringStartedAt: null,
      scoringDeadlineAt: null,
      scoringRefreshExpired: false,
      scoringRefreshLoading: false,
      ACTIVE_SCORING_INTERVAL: 5000,
      POST_GRADE_INTERVAL: 10000,
      SCORING_TIMEOUT: 15 * 60 * 1000,
      pendingBuyoutCheckAction: null,
      oldIdentifierStatusOverride: null,
      newIdentifierStatusOverride: null,
      identifierOverflowAttempts: {
        old: null,
        new: null,
      },
      suppressIdentifierSubmitUntil: 0,
      pollingAssessment: null,
      pendingAssessmentNextStep: null,
      assessmentResultLoading: false,
      assessmentResultPopup: {
        visible: false,
        title: '',
        message: '',
        action: null,
        nextStep: null,
        showChanges: false,
        previousGrade: null,
        currentGrade: null,
        previousPrice: null,
        currentPrice: null,
        reasons: [],
      },
    }
  },
  computed: {
    ...mapState('buyphones', ['deal', 'scorring_popup','model', 'price','ourDiscount', 'grade', 'answers', 'screenThree', 'discounts', 'selectDiscount', 'subsidies', 'scorring', 'btag', 'manual', 'mData','cSubsidy','discount','questions', 'answers', 'next_step', 'assessment', 'finalAssessment']),
    ...mapState('user', ['user']),
    isCurrentScreenOrder() {
      return !!this.model && this.model.btag === this.screenOrderBtag;
    },
    isFinalDealState() {
      return !!this.deal && ['locked', 'buy', 'refund', 'cancel'].includes(this.deal.state);
    },
    isPreliminaryAssessment() {
      return this.scorring == 6;
    },
    hasPendingAssessmentNavigation() {
      return !!this.pendingAssessmentNextStep;
    },
    isActiveVideoAssessment() {
      return this.user?.flowType === 'mts'
        && !this.hasPendingAssessmentNavigation
        && this.assessment
        && this.assessment.type === 'video'
        && ['required', 'in_progress'].includes(this.assessment.status);
    },
    mtsOfferTitle() {
      if (this.user.flowType == 'mts') {
        return this.hasFinalMtsAssessment ? 'Наше предложение' : 'Оценка устройства';
      }

      return 'Наше предложение';
    },
    hasFinalMtsAssessment() {
      return this.scorring == 3
        || this.scorring == 4
        || this.scorring == 5
        || this.isActiveVideoAssessment
        || this.hasPendingAssessmentNavigation;
    },
    deviceDisplayName() {
      const manufacture = this.model?.mobile?.manufacture || '';
      const modelOrigin = this.model?.mobile?.modelOrigin || '';
      const capacity = this.model?.mobile?.Capacity || '';
      const normalizedModel = this.normalizeStorage(modelOrigin);
      const normalizedCapacity = this.normalizeStorage(capacity);
      const shouldAppendCapacity = normalizedCapacity && !normalizedModel.includes(normalizedCapacity);

      return [manufacture, modelOrigin, shouldAppendCapacity ? capacity : '']
        .filter(Boolean)
        .join(' ');
    },
    preliminaryValue: {
      get() {
        return this.$store.state.buyphones.preliminary;
      },
      set(value) {
        this.SET_PRELIMINARY(value);
        if (value) {
          this.SET_FINAL_ASSESSMENT(false);
        }
      }
    },
    showPreliminaryCheckbox() {
      return this.user?.preliminaryCheckEnabled === true;
    },
    isImeiRequiredOnScreenThree() {
      return this.user?.flowType === 'mts';
    },
    canProceedWithoutImeiGate() {
      return !this.isImeiRequiredOnScreenThree || !!this.model?.imei || this.oldIdentifierStatus.valid;
    },
    effectiveImei() {
      return this.model?.imei || this.oldIMEI;
    },
    oldIdentifierStatus() {
      if (this.oldIdentifierStatusOverride) {
        return this.oldIdentifierStatusOverride;
      }

      if (!this.isImeiRequiredOnScreenThree && !String(this.oldIMEI || '').trim()) {
        return createOptionalIdentifierStatus();
      }

      return validateDeviceIdentifier(this.oldIMEI, {
        allowSerial: true,
        label: 'IMEI',
      });
    },
    newIdentifierStatus() {
      if (this.newIdentifierStatusOverride) {
        return this.newIdentifierStatusOverride;
      }

      if (!this.isNewIdentifierRequired && !String(this.manualData.newImei || '').trim()) {
        return createOptionalIdentifierStatus();
      }

      return validateDeviceIdentifier(this.manualData.newImei, {
        allowSerial: true,
        label: 'IMEI',
      });
    },
    isNewIdentifierRequired() {
      return !this.deal && Number(this.manual) > 0 && !!this.chooseSubsidy;
    },
    canProceedWithIdentifiers() {
      const oldIdentifierValid = this.canProceedWithoutImeiGate;
      const newIdentifierValid = !this.isNewIdentifierRequired || this.newIdentifierStatus.valid;

      return oldIdentifierValid && newIdentifierValid;
    }
  },
  watch: {
    deal(value) {
      if (value && ['locked', 'buy', 'cancel', 'refund'].includes(value.state)) {
        this.clearScoringRefreshState();
        this.changeScreenThree({ show1: true, show2: false, show3: false, show4: false });
      }
    },
    oldIMEI(value, previousValue) {
      if (value !== previousValue) {
        this.pendingBuyoutCheckAction = null;
        this.resetBuyoutCheckState();
      }
    },
    manual(value, previousValue) {
      if (value !== previousValue) {
        this.ensureManualTelegramPolling(value);
      }
    },
    finalAssessment(value) {
      if (
        value &&
        Number(this.scorring) === 6 &&
        this.assessment &&
        !this.scoringDeadlineAt &&
        !this.scorringCheckTimer
      ) {
        this.startScoringPollingWindow();
        this.checkScorring();
      }
    }
  },
  mounted() {
    this.chooseSubsidy = this.cSubsidy;
    this.manualData = { ...this.mData};
    if (this.isFinalDealState) {
      this.changeScreenThree({ show1: true, show2: false, show3: false, show4: false });
    } else this.ensureManualTelegramPolling(this.manual);
  },
  props: {
    changeScreenFunction: {
      type: Function,
      default: null
    }
  },
  methods: {
    ...mapActions('buyphones', ['showScorringPopup','getQuestions','closeScorringPopup','getOrder','checkStatusScorring','agreeModel', 'changeDiscount', 'updatePrice', 'clearDiscount','setError','chooseSubsidies','saveManualData','setModelIMEI','changeScreenThree', 'startBuyoutCheck']),
    ...mapMutations('buyphones', ['SET_MODEL', 'CHANGE_SCREEN_THREE', 'SET_FINAL_ASSESSMENT', 'SET_PRELIMINARY', 'SET_ERROR_SEARCH']),
    getScreenIdentifierOverrideKey(field) {
      return field === 'new'
        ? 'newIdentifierStatusOverride'
        : 'oldIdentifierStatusOverride';
    },
    setScreenIdentifierValue(field, value) {
      if (field === 'new') {
        this.manualData.newImei = value;
        return;
      }

      this.oldIMEI = value;
    },
    clearScreenIdentifierInputState(field) {
      this[this.getScreenIdentifierOverrideKey(field)] = null;
      this.identifierOverflowAttempts[field] = null;
      this.suppressIdentifierSubmitUntil = 0;

      if (field === 'old') {
        this.pendingBuyoutCheckAction = null;
        this.resetBuyoutCheckState();
      }
    },
    handleScreenIdentifierBeforeInput(event, field) {
      if (event.inputType && event.inputType.startsWith('delete')) {
        this.clearScreenIdentifierInputState(field);
        return;
      }

      const projectedValue = getProjectedIdentifierValue(event.target, event.data || '');
      if (projectedValue.length > IDENTIFIER_MAX_LENGTH) {
        this.handleScreenIdentifierOverflow(event, field, projectedValue);
        return;
      }

      this.clearScreenIdentifierInputState(field);
    },
    handleScreenIdentifierPaste(event, field) {
      const pastedValue = event.clipboardData?.getData('text') || '';
      const projectedValue = getProjectedIdentifierValue(event.target, pastedValue);

      if (projectedValue.length > IDENTIFIER_MAX_LENGTH) {
        this.handleScreenIdentifierOverflow(event, field, projectedValue);
        return;
      }

      this.clearScreenIdentifierInputState(field);
    },
    handleScreenIdentifierInput(event, field) {
      const rawValue = String(event.target.value || '');

      if (rawValue.length > IDENTIFIER_MAX_LENGTH) {
        const limitedValue = rawValue.toUpperCase().slice(0, IDENTIFIER_MAX_LENGTH);
        event.target.value = limitedValue;
        this.setScreenIdentifierValue(field, limitedValue);
        this.handleScreenIdentifierOverflow(event, field, rawValue);
        return;
      }

      const value = rawValue.toUpperCase();
      event.target.value = value;
      this[this.getScreenIdentifierOverrideKey(field)] = null;
      this.suppressIdentifierSubmitUntil = 0;
      this.identifierOverflowAttempts[field] = null;
      this.setScreenIdentifierValue(field, value);

      if (field === 'old') {
        this.pendingBuyoutCheckAction = null;
        this.resetBuyoutCheckState();
      }
    },
    handleScreenIdentifierOverflow(event, field, projectedValue) {
      event?.preventDefault();
      const attempt = trackIdentifierOverflowAttempt(
        this.identifierOverflowAttempts[field],
        event?.target?.value,
        projectedValue,
      );
      this.identifierOverflowAttempts[field] = attempt;

      if (isPossibleEidAttempt(attempt)) {
        this.rejectOversizedScreenIdentifier(event, field);
        return;
      }

      this[this.getScreenIdentifierOverrideKey(field)] = createTooLongIdentifierStatus({
        allowSerial: true,
        length: attempt.attemptedLength,
      });
      this.suppressIdentifierSubmitUntil = 0;

      if (field === 'old') {
        this.pendingBuyoutCheckAction = null;
        this.resetBuyoutCheckState();
      }
    },
    rejectOversizedScreenIdentifier(event, field) {
      event?.preventDefault();
      this.setScreenIdentifierValue(field, '');
      this[this.getScreenIdentifierOverrideKey(field)] = createPossibleEidStatus();
      this.identifierOverflowAttempts[field] = null;
      this.suppressIdentifierSubmitUntil = Date.now() + 350;

      if (field === 'old') {
        this.pendingBuyoutCheckAction = null;
        this.resetBuyoutCheckState();
      }

      if (event?.target) {
        event.target.value = '';
        event.target.blur();
      }

      this.setError({
        type: 'possibleEid',
        message: 'Вы считали не IMEI. IMEI должен содержать 15 цифр. Убедитесь, что сканируете IMEI, а не EID',
      });
    },
    showScreenIdentifierPopup(status, label = 'IMEI') {
      const isPossibleEid = status.reason === IDENTIFIER_REASONS.POSSIBLE_EID;
      this.setError({
        type: isPossibleEid ? 'possibleEid' : 'invalidIdentifier',
        message: isPossibleEid
          ? 'Вы считали не IMEI. IMEI должен содержать 15 цифр. Убедитесь, что сканируете IMEI, а не EID'
          : getInvalidIdentifierPopupMessage(status, { allowSerial: true, label }),
      });
    },
    validateOldIdentifierForAction() {
      if (!this.isImeiRequiredOnScreenThree && !this.effectiveImei) {
        return true;
      }

      if (this.model?.imei) {
        return true;
      }

      if (!this.oldIdentifierStatus.valid) {
        this.showScreenIdentifierPopup(this.oldIdentifierStatus);
        return false;
      }

      return true;
    },
    validateNewIdentifierForAction({ required = false } = {}) {
      const value = String(this.manualData.newImei || '').trim();

      if (!value && !required) {
        return true;
      }

      if (!this.newIdentifierStatus.valid) {
        this.showScreenIdentifierPopup(this.newIdentifierStatus);
        return false;
      }

      return true;
    },
    validateScreenIdentifiersForAction({ requireNewIdentifier = false } = {}) {
      if (Date.now() < this.suppressIdentifierSubmitUntil) {
        return false;
      }

      return this.validateOldIdentifierForAction()
        && this.validateNewIdentifierForAction({ required: requireNewIdentifier });
    },
    clearScorringTimer() {
      if (this.scorringCheckTimer) {
        clearTimeout(this.scorringCheckTimer);
        this.scorringCheckTimer = null;
      }
    },
    clearScoringRefreshState() {
      this.clearScorringTimer();
      this.scoringStartedAt = null;
      this.scoringDeadlineAt = null;
      this.scoringRefreshExpired = false;
      this.scoringRefreshLoading = false;
      this.pollingAssessment = null;
    },
    startScoringPollingWindow() {
      this.clearScorringTimer();
      this.scoringStartedAt = Date.now();
      this.scoringDeadlineAt = this.scoringStartedAt + this.SCORING_TIMEOUT;
      this.scoringRefreshExpired = false;
      this.pollingAssessment = this.assessment ? { ...this.assessment } : null;
    },
    isScoringPollingExpired() {
      return this.scoringDeadlineAt && Date.now() >= this.scoringDeadlineAt;
    },
    expireScoringRefresh() {
      this.clearScorringTimer();
      this.scoringRefreshExpired = true;
      this.closeScorringPopup();
    },
    scheduleScorringCheck(interval) {
      if (!this.scoringDeadlineAt) {
        return;
      }

      if (this.isScoringPollingExpired()) {
        this.expireScoringRefresh();
        return;
      }

      const delay = Math.min(interval, this.scoringDeadlineAt - Date.now());
      this.scorringCheckTimer = setTimeout(this.checkScorring, delay);
    },
    isManualTelegramScoringPending(manual = this.manual) {
      const manualStatus = Number(manual);

      return manualStatus > 1 && manualStatus < 10;
    },
    isScoringInProgress() {
      return this.scorring == 1
        || this.scorring == 2
        || (this.scorring == 6 && this.$store.state.buyphones.finalAssessment)
        || this.isManualTelegramScoringPending();
    },
    shouldPollAfterAgree(response) {
      if (!response) {
        return false;
      }

      return this.isManualTelegramScoringPending(response && response.manual)
        || response.scorring == 1
        || response.scorring == 2
        || response.scorring == 5;
    },
    ensureManualTelegramPolling(manual = this.manual) {
      if (!this.isManualTelegramScoringPending(manual)) {
        return;
      }

      if (!this.model || !this.model.btag || this.scoringDeadlineAt || this.scorringCheckTimer) {
        return;
      }

      this.startScoringPollingWindow();
      this.checkScorring();
    },
    getScoringPayload() {
      return {
        btag: this.model.btag,
        subsidy: this.chooseSubsidy ? this.chooseSubsidy.subsidyId : null,
        subsidyModel: this.chooseSubsidy,
        imei: this.effectiveImei
      };
    },
    getCurrentScoringSnapshot() {
      return {
        grade: this.grade,
        price: this.price,
        ourDiscount: this.ourDiscount,
        discount: this.discount
      };
    },
    isSameAssessment(left, right) {
      return !!left && !!right && left.id === right.id && left.type === right.type;
    },
    getAssessmentTitle(type) {
      return type === 'video' ? 'Видеопроверка завершена' : 'Фотооценка завершена';
    },
    resetAssessmentResultPopup() {
      this.assessmentResultPopup = {
        visible: false,
        title: '',
        message: '',
        action: null,
        nextStep: null,
        showChanges: false,
        previousGrade: null,
        currentGrade: null,
        previousPrice: null,
        currentPrice: null,
        reasons: [],
      };
    },
    showAssessmentResultPopup({ type, message, action, nextStep = null, outcome = null }) {
      const previous = outcome && outcome.previous ? outcome.previous : {};
      const current = outcome && outcome.current ? outcome.current : {};
      const showChanges = !!outcome && (outcome.gradeChanged || outcome.priceChanged);

      this.assessmentResultPopup = {
        visible: true,
        title: this.getAssessmentTitle(type),
        message,
        action,
        nextStep,
        showChanges,
        previousGrade: previous.grade || null,
        currentGrade: current.grade || null,
        previousPrice: previous.price === undefined ? null : previous.price,
        currentPrice: current.price === undefined ? null : current.price,
        reasons: Array.isArray(outcome && outcome.reasons)
          ? outcome.reasons.filter(Boolean)
          : [],
      };
    },
    stopAssessmentPolling() {
      this.clearScorringTimer();
      this.scoringStartedAt = null;
      this.scoringDeadlineAt = null;
      this.scoringRefreshExpired = false;
      this.pollingAssessment = null;
    },
    async refreshOrderPreservingImei() {
      const currentImei = this.effectiveImei;
      const response = await this.getOrder({ btag: this.model.btag, loader: false });

      if (currentImei && this.model && !this.model.imei) {
        this.setModelIMEI(currentImei);
      }

      return response;
    },
    async handleTrackedAssessmentPollingResponse(response, polledAssessment, { scheduleNext = true } = {}) {
      if (!polledAssessment || !response) {
        return false;
      }

      if (response.error === 'assessmentRequired' && response.assessment) {
        if (this.isSameAssessment(polledAssessment, response.assessment)) {
          if (scheduleNext) {
            this.scheduleScorringCheck(this.ACTIVE_SCORING_INTERVAL);
          }
          return true;
        }

        this.stopAssessmentPolling();
        this.closeScorringPopup();
        await this.refreshOrderPreservingImei();
        if (polledAssessment.type === 'photo') {
          this.pendingAssessmentNextStep = 'questions';
        }
        this.showAssessmentResultPopup({
          type: polledAssessment.type,
          message: polledAssessment.type === 'photo'
            ? 'Фотооценка завершена. Далее проведите техническую оценку устройства. По результатам технической оценки грейд и цена могут измениться.'
            : 'Проверка завершена. Для продолжения требуется следующая оценка устройства.',
          action: polledAssessment.type === 'photo' ? 'acknowledge' : 'stay',
        });
        return true;
      }

      if (response.error === 'preliminaryAssessment') {
        if (this.finalAssessment) {
          if (response.assessment && !this.isSameAssessment(polledAssessment, response.assessment)) {
            this.pollingAssessment = { ...response.assessment };
          }

          if (scheduleNext) {
            this.scheduleScorringCheck(this.ACTIVE_SCORING_INTERVAL);
          }
          return true;
        }

        this.stopAssessmentPolling();
        this.SET_FINAL_ASSESSMENT(false);
        this.showScorringPopup();
        return true;
      }

      if (response.error === 'manualChangeGrade') {
        this.stopAssessmentPolling();
        this.closeScorringPopup();
        await this.refreshOrderPreservingImei();

        if (response.assessmentOutcome) {
          this.showAssessmentResultPopup({
            type: response.assessmentOutcome.type || polledAssessment.type,
            message: 'Итоговая оценка устройства изменилась.',
            action: 'agree',
            outcome: response.assessmentOutcome,
          });
        } else {
          this.setError('manualChangeGrade');
        }
        return true;
      }

      if (response.error === 'scorringRefuse') {
        this.stopAssessmentPolling();
        this.closeScorringPopup();
        this.setError('scorringRefuse');
        return true;
      }

      if (response.error === 'buyoutSideUnknown') {
        this.stopAssessmentPolling();
        this.closeScorringPopup();
        return true;
      }

      if (response.status === 'ok' && !response.ErrorDetails) {
        this.stopAssessmentPolling();
        this.closeScorringPopup();
        await this.refreshOrderPreservingImei();
        const requiresTechnicalAssessment = polledAssessment.type === 'photo'
          && response.nextStep === 'questions';
        if (response.nextStep) {
          this.pendingAssessmentNextStep = response.nextStep;
        }
        this.showAssessmentResultPopup({
          type: polledAssessment.type,
          message: polledAssessment.type === 'video'
            ? 'Видеопроверка устройства успешно завершена.'
            : requiresTechnicalAssessment
              ? 'Фотооценка завершена. Далее проведите техническую оценку устройства. По результатам технической оценки грейд и цена могут измениться.'
              : 'Фотооценка устройства успешно завершена.',
          action: requiresTechnicalAssessment ? 'acknowledge' : 'stay',
          nextStep: response.nextStep || null,
        });
        return true;
      }

      return false;
    },
    checkScoringChanges(previousValues) {
      if (this.scorring != 5 || this.user.flowType == 'mvm') {
        return;
      }

      const priceChanged = Number(previousValues.price) !== Number(this.price);
      const gradeChanged = previousValues.grade !== this.grade;
      const ourDiscountChanged = Number(previousValues.ourDiscount || 0) !== Number(this.ourDiscount || 0);
      const discountChanged = Number(previousValues.discount || 0) !== Number(this.discount || 0);

      if (priceChanged || gradeChanged || ourDiscountChanged || discountChanged) {
        this.chooseSubsidy = null;
        this.setError("manualChangeGrade")
      }
    },
    async refreshOrderAfterScoring() {
      this.closeScorringPopup();
      const res = await this.refreshOrderPreservingImei();

      if (!res) {
        return;
      }

      if (this.chooseSubsidy){
        const currentSubsidyModel = this.cSubsidy || this.chooseSubsidy;
        const responseSubsidies = Array.isArray(res.subsidies) ? res.subsidies : [];

        // Ищем в массиве объектов subsidies объект с deviceModel равным cSubsidy.deviceModel
        const foundSubsidy = responseSubsidies.find(subsidy => subsidy.deviceModel === currentSubsidyModel.deviceModel);
        // Если цена отличается, то обновляем chooseSubsidy
        if (!foundSubsidy || (foundSubsidy && foundSubsidy.subsidyPrice !== this.chooseSubsidy.subsidyPrice)) {
          this.chooseSubsidy = null;
          this.chooseSubsidies(null)
        }
      }
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    async runScoringStatusCheck({ scheduleNext = true, forceOrderRefresh = false } = {}) {
      if (!this.isCurrentScreenOrder) return;
      if (this.deal && ['locked', 'buy', 'refund', 'cancel'].includes(this.deal.state)) {
        this.clearScoringRefreshState();
        return;
      }
      if (scheduleNext && this.isScoringPollingExpired()) {
        this.expireScoringRefresh();
        return;
      }

      const previousValues = this.getCurrentScoringSnapshot();

      const polledAssessment = this.pollingAssessment ? { ...this.pollingAssessment } : null;
      const response = await this.checkStatusScorring(this.getScoringPayload())
      if (!this.isCurrentScreenOrder) return;

      if (this.scorringCheckTimer) {
        this.clearScorringTimer();
      }

      if (await this.handleTrackedAssessmentPollingResponse(response, polledAssessment, { scheduleNext })) {
        return;
      }

      if(this.isScoringInProgress()){
        if (forceOrderRefresh) {
          await this.refreshOrderAfterScoring();
          this.checkScoringChanges(previousValues);
        }

        if (scheduleNext) {
          this.scheduleScorringCheck(this.ACTIVE_SCORING_INTERVAL)
        }
        return;
      }

      await this.refreshOrderAfterScoring();
      this.checkScoringChanges(previousValues);

      if (scheduleNext && !this.deal) {
        this.scheduleScorringCheck(this.POST_GRADE_INTERVAL)
      }
    },
    async ensureScreenThreeBuyoutCheck(actionName) {
      if (!this.validateOldIdentifierForAction()) {
        return false;
      }

      if (!this.isImeiRequiredOnScreenThree && !this.effectiveImei) {
        return true;
      }

      if (this.model.imei) {
        return true;
      }

      this.pendingBuyoutCheckAction = actionName;
      const canContinue = await this.ensureBuyoutCheckPassed(this.oldIMEI);

      if (canContinue) {
        this.pendingBuyoutCheckAction = null;
      }

      return canContinue;
    },
    async continueBuyoutWithRisk() {
      const actionName = this.pendingBuyoutCheckAction;

      this.markBuyoutCheckPassed(this.oldIMEI);
      this.pendingBuyoutCheckAction = null;

      if (actionName && typeof this[actionName] === 'function') {
        await this[actionName]();
      }
    },
    onBuyoutCheckError(message) {
      this.SET_ERROR_SEARCH(message);
    },
    handleBuyoutCheckPopupClose() {
      this.pendingBuyoutCheckAction = null;
      this.closeBuyoutCheckPopup();
    },
    executeConfirmFlow() {
      this.startScoringPollingWindow();
      this.showScorringPopup()
      this.checkScorring()
    },
    executeFinalAssessmentFlow() {
      this.SET_FINAL_ASSESSMENT(true);
      this.executeConfirmFlow();
    },
    async confirm(){
      if (!this.validateScreenIdentifiersForAction({
        requireNewIdentifier: this.isNewIdentifierRequired,
      })) {
        return false;
      }

      if (!(await this.ensureScreenThreeBuyoutCheck('executeConfirmFlow'))) {
        return false;
      }
      this.executeConfirmFlow()
    },
    startMtsAssessment() {
      this.SET_FINAL_ASSESSMENT(false);
      if (!this.preliminaryValue) {
        this.SET_PRELIMINARY(false);
      }

      this.confirm();
    },
    executeVideoAssessmentFlow() {
      this.SET_PRELIMINARY(false);
      this.SET_FINAL_ASSESSMENT(false);
      this.executeConfirmFlow();
    },
    async startVideoAssessment() {
      if (!this.validateScreenIdentifiersForAction({
        requireNewIdentifier: this.isNewIdentifierRequired,
      })) {
        return;
      }

      if (!(await this.ensureScreenThreeBuyoutCheck('executeVideoAssessmentFlow'))) {
        return;
      }

      if (!this.model.imei && this.effectiveImei) {
        this.setModelIMEI(this.effectiveImei);
      }
      this.executeVideoAssessmentFlow();
    },
    async requestFinalAssessment() {
      if (!this.validateScreenIdentifiersForAction({
        requireNewIdentifier: this.isNewIdentifierRequired,
      })) {
        return;
      }

      if (!(await this.ensureScreenThreeBuyoutCheck('executeFinalAssessmentFlow'))) {
        return;
      }
      this.executeFinalAssessmentFlow();
    },
    async checkScorring(){
      await this.runScoringStatusCheck({ scheduleNext: true });
    },
    async refreshScoringStatus() {
      if (this.scoringRefreshLoading) {
        return;
      }

      this.scoringRefreshLoading = true;
      this.clearScorringTimer();

      try {
        await this.runScoringStatusCheck({ scheduleNext: false, forceOrderRefresh: true });
      } finally {
        this.scoringRefreshLoading = false;
        this.scoringRefreshExpired = true;
      }
    },
    goToNextScreen(nextStep = this.next_step) {
      this.clearScoringRefreshState();
      
      // Используем переданную функцию напрямую
      if (this.changeScreenFunction) {
        if (nextStep == "final") {
          this.changeScreenFunction({type: 'next', id: 2});
        } else if (nextStep == "questions") {
          this.getQuestions(this.model.btag);
          this.changeScreenFunction({type: 'prev', id: 2});
        } else if (nextStep == "contract") {
          this.changeScreenThree({ show1: false, show2: true });
        }
      } else {
        console.error("changeScreenFunction не передана через props");
        // Fallback - используем emit
        this.$emit('changeScreen', {type: 'prev', id: 2});
      }
    },
    async next() {
      var next = true;
      if (!this.isCurrentScreenOrder || this.isFinalDealState) return;

      if (this.pendingAssessmentNextStep) {
        const nextStep = this.pendingAssessmentNextStep;
        this.pendingAssessmentNextStep = null;
        this.goToNextScreen(nextStep);
        return;
      }

      if (this.isActiveVideoAssessment) {
        await this.startVideoAssessment();
        return;
      }

      this.clearScoringRefreshState();

      if (!this.validateScreenIdentifiersForAction({
        requireNewIdentifier: this.isNewIdentifierRequired,
      })) {
        return;
      }

      if (!this.deal && this.manual > 0 && this.chooseSubsidy && (!this.manualData.chooseStorage || !this.manualData.chooseColor || !this.manualData.newArticle)){
        this.setError("notAllDataEntered")
        next = false;
      }
      if (!next) {
        return;
      }

      if (!(await this.ensureScreenThreeBuyoutCheck('next'))) {
        return;
      }

      if (!this.model.imei && this.effectiveImei) {
        this.setModelIMEI(this.effectiveImei)
      }
      if (!this.isCurrentScreenOrder) return;
      if (this.deal && this.deal.state !== 'assessment') {
        if (!this.$refs.dealConditions || !(await this.$refs.dealConditions.save())) return;
        if (!this.isCurrentScreenOrder) return;
      }
      if (!this.deal) {
        this.chooseSubsidies(this.chooseSubsidy);
        this.saveManualData(this.manualData);
      }
      const response = await this.agreeModel({
        btag: this.model.btag,
        subsidy: this.chooseSubsidy ? this.chooseSubsidy.subsidyId : null,
        subsidyModel: this.chooseSubsidy,
        storage: this.manualData.chooseStorage, 
        color: this.manualData.chooseColor,
        article: this.manualData.newArticle,
        price: this.manualData.newPrice,
        newImei: this.manualData.newImei,
        imei: this.effectiveImei
      })
      if (!this.isCurrentScreenOrder || (!response && this.deal)) return;
      if (response){
        if (response.error === 'articleColorGradeUnavailable') {
          return;
        }
        if (response.error === 'buyoutSideUnknown') {
          return;
        }
        if (response.error === 'assessmentRequired' && response.assessment) {
          this.startScoringPollingWindow();
          this.showScorringPopup();
          this.checkScorring();
          return;
        }
        if (response.error === 'manualChangeGrade' && response.assessmentOutcome) {
          this.showAssessmentResultPopup({
            type: response.assessmentOutcome.type || 'photo',
            message: 'Итоговая оценка устройства изменилась.',
            action: 'agree',
            outcome: response.assessmentOutcome,
          });
          return;
        }
        if (response.ErrorDetails || (this.deal && response.error)) {
          next = false;
        } else {
          if (response.scorring == 6) {
            this.SET_FINAL_ASSESSMENT(false);
            this.startScoringPollingWindow();
            this.scheduleScorringCheck(this.POST_GRADE_INTERVAL);
            this.showScorringPopup();
            return;
          }
          if (this.shouldPollAfterAgree(response)) {
            this.startScoringPollingWindow();
            this.checkScorring()
            return;
          }
        }

      }
      if (next) {
        this.goToNextScreen();
      }
      // this.$router.push(`/buyout/create?id=${this.model.btag}`);
    },
    formatAssessmentGrade(value) {
      if (!value) {
        return 'Не указано';
      }

      if (this.user?.flowType !== 'mts') {
        return value;
      }

      const gradeMap = {
        'Grade A': 'Grade H',
        'Grade С': 'Grade C',
        'Grade E': 'Grade Z',
      };
      return gradeMap[value] || value;
    },
    formatAssessmentPrice(value) {
      if (value === null || value === undefined || value === '') {
        return 'Не указана';
      }

      return `${new Intl.NumberFormat('ru-RU').format(Number(value))} ${this.user.currency}`;
    },
    async continueAfterAssessmentResult() {
      if (this.assessmentResultLoading) {
        return;
      }

      const action = this.assessmentResultPopup.action;

      if (action === 'stay') {
        this.resetAssessmentResultPopup();
        return;
      }

      if (action === 'next') {
        this.resetAssessmentResultPopup();
        this.goToNextScreen();
        return;
      }

      if (action === 'acknowledge') {
        this.resetAssessmentResultPopup();
        return;
      }

      if (action === 'agree') {
        this.assessmentResultLoading = true;
        this.resetAssessmentResultPopup();
        try {
          await this.next();
        } finally {
          this.assessmentResultLoading = false;
        }
      }
    },
    minimumGrade(){
      var minGrade = 0;
      for (const group of this.questions) {
        for (const question of group.questions) {          
          if(this.answers.find((element) => { if (element.id == question.id){return element.answer}})){
            minGrade = question.grade > minGrade ? question.grade : minGrade;
          }
        }
      }
      return minGrade
    },
    haveGroupAnswer(group){
      for (const question of group.questions) {
        if(this.answers.find((element) => { if (element.id == question.id){return element.answer}})){
          return true
        }
      }

      return false
    },
    async buyDiscount(discountId,priceId,price,discountName) {
      const response = await this.changeDiscount({
        btag: this.model.btag,
        discountId: discountId,
        priceId: priceId,
      })
      if (response.status == 'ok'){
        this.clearDiscount(discountName)
        this.updatePrice(price)

      }

    },
    changeScreen() {
      this.clearScoringRefreshState();
      this.$emit('changeScreen', {type: 'next', id: 2})
    },
    // Добавляем метод для полной очистки при закрытии
    handleLeave() {
      this.clearScoringRefreshState();
      this.$emit('leave');
    },
    nameWithLang ({ deviceModel, subsidyPrice }) {
      return `${deviceModel} — ${subsidyPrice}`
    },
    normalizeStorage(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/\s+/g, '')
    }
  },
  beforeMount() {
    for (var s in this.subsidies){
      var subsidy = this.subsidies[s]
      if (subsidy.deviceModel == this.cSubsidy){
        this.chooseSubsidy = subsidy;
        this.chooseSubsidies(subsidy);
        break;
      }
    }
  },
  beforeDestroy() {
    // Очистить таймер, если компонент уничтожается
    this.clearScoringRefreshState();
  },
  beforeRouteLeave(to, from, next) {
    // Очистить таймер при переходе на другой маршрут
    this.clearScoringRefreshState();
    next();
  },
  deactivated() {
    // Очистить таймер, если компонент деактивирован (при использовании keep-alive)
    this.clearScoringRefreshState();
  }
}
</script>

<style lang="css">
</style>
